import {
  GET_GROUP_MEMBERS_START,
  GET_GROUP_MEMBERS_SUCCESS,
  GET_GROUP_MEMBERS_FAIL,
  ADD_GROUP_MEMBERS_DIALOG_OPEN,
  ADD_GROUP_MEMBERS_DIALOG_CLOSE,
} from 'actions/group';

import { getListPageSuccessNewData } from '../utils';

export const defaultState = {
  loading: true,
  data: [],
  dataLoaded: false,
  error: false,
  links: {},
  total: 0,
  isDialogOpen: false,
};

export default function groupMembersList(state = defaultState, action) {
  switch (action.type) {
    case GET_GROUP_MEMBERS_SUCCESS: {
      const { data, links, total } = action.payload;
      return {
        ...state,
        data: getListPageSuccessNewData(
          state,
          data.map(d => d.member),
          links,
        ),
        dataLoaded: true,
        total,
        links,
        loading: false,
        error: false,
      };
    }
    case GET_GROUP_MEMBERS_START: {
      return {
        ...state,
        data: [],
        loading: true,
        error: false,
      };
    }
    case GET_GROUP_MEMBERS_FAIL: {
      return {
        ...state,
        loading: false,
        error: true,
      };
    }
    case ADD_GROUP_MEMBERS_DIALOG_OPEN: {
      return {
        ...state,
        isDialogOpen: true,
      };
    }
    case ADD_GROUP_MEMBERS_DIALOG_CLOSE: {
      return {
        ...state,
        isDialogOpen: false,
      };
    }
    default:
      return state;
  }
}
